var FeatureFlagService_1;
import { __decorate } from "tslib";
import { EMPTY, filter, switchMap, take } from 'rxjs';
import { Inject, Injectable, Optional } from '@angular/core';
import { FeatureFlagConfigurationState, InitializeFeatureFlagConfiguration } from '../state';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ConstructorName } from '../decorators';
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "./monitoring.service";
import * as i3 from "@ngxs/store";
let FeatureFlagService = class FeatureFlagService {
  static {
    FeatureFlagService_1 = this;
  }
  portalPath;
  api;
  monitoringService;
  store;
  destroyed;
  apiVersion = '1';
  url = 'feature-flag-service';
  apiCallInProgress = false;
  constructor(portalPath, api, monitoringService, store, destroyed) {
    this.portalPath = portalPath;
    this.api = api;
    this.monitoringService = monitoringService;
    this.store = store;
    this.destroyed = destroyed;
    this.monitoringService.sendTrackEvent(Reflect.getMetadata('constructorName', FeatureFlagService_1), 'constructor');
  }
  getFeatureFlagConfigurationForStore(forceReload = false) {
    this.store.select(FeatureFlagConfigurationState.features).pipe(filter(features => !features), take(1), switchMap(features => {
      if ((forceReload || !features) && !this.apiCallInProgress) {
        this.apiCallInProgress = true;
        return this.getFeatureFlagConfigurationForUser();
      }
      return EMPTY;
    })).pipe(takeUntilDestroyed(this.destroyed)).subscribe({
      next: result => {
        this.store.dispatch(new InitializeFeatureFlagConfiguration({
          features: result.features
        }));
      },
      error: error => {
        // Show error in console if feature Flag Call fails
        // eslint-disable-next-line no-console
        console.error('An Error occurred while fetching feature flag configuration for the store', error);
        this.store.dispatch(new InitializeFeatureFlagConfiguration({
          features: {}
        }));
        this.apiCallInProgress = false;
      },
      complete: () => {
        this.apiCallInProgress = false;
      }
    });
  }
  getFeatureFlagConfigurationForUser() {
    return this.api.get(`${this.url}/v${this.apiVersion}/feature-flags/configuration/me`);
  }
  setUrl(url) {
    if (url) {
      this.url = (this.portalPath || 'portal') + url;
    }
    return this;
  }
  setApiVersion(apiVersion) {
    this.apiVersion = apiVersion ?? this.apiVersion;
    return this;
  }
  static ɵfac = function FeatureFlagService_Factory(t) {
    return new (t || FeatureFlagService)(i0.ɵɵinject('portalPath', 8), i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.MonitoringService), i0.ɵɵinject(i3.Store), i0.ɵɵinject(i0.DestroyRef));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: FeatureFlagService,
    factory: FeatureFlagService.ɵfac,
    providedIn: 'root'
  });
};
FeatureFlagService = FeatureFlagService_1 = __decorate([ConstructorName('FeatureFlagService')], FeatureFlagService);
export { FeatureFlagService };
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FeatureFlagService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: ['portalPath']
    }]
  }, {
    type: i1.ApiService
  }, {
    type: i2.MonitoringService
  }, {
    type: i3.Store
  }, {
    type: i0.DestroyRef
  }], null);
})();
